/**
 * @ngdoc service
 * @name  common.service:acceptanceService
 * @description
 *
 * Servicio para añadir distintas funcionalidades de cupones al módulo de Massimo Dutti Feel
 */

 (function () {
    'use strict';

    angular.module('itxApp.common').factory('acceptanceService', acceptanceService);

    acceptanceService.$inject = [
        '$q', 
        'crmService', 
        'timestampSvc',
        'ItxConfigurationSvc',
        '$http'
    ];

    function acceptanceService(
        $q, 
        crmService, 
        timestampSvc,
        ItxConfigurationSvc,
        $http
    ) {
        var _this = this;
        var service = {
            consent: _consent
        };

        _this.apiPathChina = {
            DEVELOPMENT: `https://${inditex.iProxyHostStandard}/itxrest/2/`,
            PREPRU: `https://${inditex.iProxyHostStandard}/itxrest/2/`,
            PRUSTG: `https://${inditex.iProxyHostStandard}/itxrest/2/`,
            PRO: `https://${inditex.iProxyHostStandard}/itxrest/2/`,
            STAGE: `https://${inditex.iProxyHostStandard}/itxrest/2/`
        };

        _this.apiPath = {
            DEVELOPMENT: `https://${inditex.iProxyHostStandard}/itxrest/2/`,
            PREPRU: `https://${inditex.iProxyHostStandard}/itxrest/2/`,
            PRUSTG: `https://${inditex.iProxyHostStandard}/itxrest/2/`,
            PRO: `https://${inditex.iProxyHostStandard}/itxrest/2/`,
            STAGE: `https://${inditex.iProxyHostStandard}/itxrest/2/`
        };

        this.origins = {
            NEWSLETTER: 58,
            CHECKOUT: 46,
            LOGIN: 5,
            GUEST_LOGIN: 6,
            SOCIAL_LOGIN: 141,
            REGISTRO: 10,
            COMING_SOON: 229,
            CONTACT: 608,
        }
        return service;

        /**
         * Method that sends consent of "transferenciaforzosa" or/and "datossensibles"
         * @param string from 
         * @param Array<string> types 
         * @param string logonId
         */
        function _consent( from, types, logonId ){
            from = from.toUpperCase();
            if( 
                !_this.origins.hasOwnProperty( from ) ||
                !Array.isArray( types ) || types.length < 1 ||
                logonId == undefined || logonId == null
            ){
                throw Error( "Incorrect parameters" );
            }
            var data = {
                "idXoperation": _this.origins[from],
                "logonid": logonId,
                "documentTypes": types
            }
            $http({
                method: 'POST',
                url: _baseUrl(),
                data,
                secure: false,
                params: { 
                   
                }
            })
                .then(function (response) {
                })
                .catch(function () {
                });
        }

        function _baseUrl() {
            // /itxrest/2/user/store/{{storeId}}/documents/accept
            var env = ItxConfigurationSvc.getEnvironment();
            var storeId = inditex.iStoreId;

            if (inditex.iCountryCode === 'CN') {
                return _this.apiPathChina[env] + 'user/store/' + storeId + '/documents/accept';
            } else {
                return _this.apiPath[env] + 'user/store/' + storeId + '/documents/accept';
            }
        }
    }
})();
